import styled from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { colorBrandYamahaRed, colorCoreGray700, colorCoreWhite1000, defaultTransparent, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const NewslettersTitleStyled = styled(HeadingLevel3) `
  ${getTextStyles(null, null, 18, 24)}

  color: ${colorCoreWhite1000};
`;
export const NewslettersDescriptionStyled = styled(RegularTextLevel4) `
  margin-top: 24px;

  color: ${colorCoreGray700};

  ${ADAPTIVE.maxWidth.tablet} {
    margin-top: 16px;
  }
`;
export const NewslettersSubscribeStyled = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
  margin-bottom: 32px;

  input {
    border-radius: ${CORNER_RADIUS.xs};
    box-shadow: none;
  }

  ${ADAPTIVE.minWidth.tablet} {
    flex-direction: row;
  }

  ${ADAPTIVE.minWidth.desktop} {
    margin-bottom: 24px;
  }
`;
// Rewrite default props
export const ButtonStyled = styled(Button) `
  background: ${colorBrandYamahaRed};
  color: ${colorCoreWhite1000};
  border-radius: ${CORNER_RADIUS.xs};
  border: 1px solid ${defaultTransparent};

  ${ADAPTIVE.minWidth.tablet} {
    width: auto;
    flex-shrink: 0;
  }
`;
